/**
 * Zone lap-time delta vs the fastest displayed lap, in seconds — the shared
 * format for the lap-comparison Δ column on both clients. Raw milliseconds
 * ("+547") proved unreadable; "+0.55s" is the pit-lane vocabulary.
 */
export function formatZoneTimeDelta(deltaMs: number): string {
  if (deltaMs <= 0) return '-'
  return `+${(deltaMs / 1000).toFixed(2)}s`
}
